export const services = [
  {
    id: "entretien-jardins",
    title: "Entretien de jardins",
    short:
      "Un jardin suivi, entretenu et valorisé tout au long de l'année, sans effort de votre côté.",
    description:
      "Nous prenons soin de votre jardin de A à Z : tonte soignée, désherbage rigoureux, nettoyage et entretien général. Votre extérieur reste impeccable, saison après saison.",
    image:
      "https://images.unsplash.com/photo-1641570599342-36953beede98?crop=entropy&cs=srgb&fm=jpg&q=80",
    subs: ["Tonte de pelouse", "Désherbage", "Nettoyage", "Entretien général"],
  },
  {
    id: "taille-elagage",
    title: "Taille et élagage",
    short:
      "Haies, arbustes et arbres taillés avec précision pour une silhouette nette et une belle santé végétale.",
    description:
      "Taille de haies, taille d'arbustes, entretien des arbres et élagage selon les besoins : nous intervenons avec le bon geste, au bon moment, pour la santé et l'esthétique de vos végétaux.",
    image:
      "https://images.unsplash.com/photo-1734079692079-172d8243ebd3?crop=entropy&cs=srgb&fm=jpg&q=80",
    subs: ["Taille de haies", "Taille d'arbustes", "Entretien des arbres", "Élagage selon les besoins"],
  },
  {
    id: "creation-amenagement",
    title: "Création et aménagement",
    short:
      "De la plantation à l'aménagement paysager, nous concevons des extérieurs qui vous ressemblent.",
    description:
      "Création de jardins, plantation, massifs, aménagement paysager et mise en valeur de vos espaces extérieurs : nous transformons votre terrain en un lieu de vie harmonieux.",
    image:
      "https://images.unsplash.com/photo-1612806527197-42af2b64884a?crop=entropy&cs=srgb&fm=jpg&q=80",
    subs: [
      "Création de jardins",
      "Plantation",
      "Massifs",
      "Aménagement paysager",
      "Mise en valeur des espaces extérieurs",
    ],
  },
  {
    id: "pelouses",
    title: "Pelouses",
    short:
      "Préparation du terrain, semis, pose de gazon et entretien : une pelouse dense et verdoyante.",
    description:
      "Préparation du terrain, semis, pose de gazon et entretien : nous créons et préservons une pelouse dense, uniforme et agréable à vivre.",
    image:
      "https://images.unsplash.com/photo-1723811898182-aff0c2eca53f?crop=entropy&cs=srgb&fm=jpg&q=80",
    subs: ["Préparation du terrain", "Semis", "Pose de gazon", "Entretien"],
  },
  {
    id: "nettoyage-exterieur",
    title: "Nettoyage extérieur",
    short:
      "Terrasses, abords et déchets verts : nous remettons vos extérieurs en parfait état.",
    description:
      "Ramassage des déchets verts, nettoyage des terrasses et des abords, remise en état des terrains : nous rendons à vos extérieurs leur propreté et leur éclat.",
    image:
      "https://images.pexels.com/photos/34861784/pexels-photo-34861784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    subs: [
      "Ramassage des déchets verts",
      "Nettoyage des terrasses",
      "Nettoyage des abords",
      "Remise en état des terrains",
    ],
  },
  {
    id: "vide-cave",
    title: "Vide-cave",
    short:
      "Vidage et débarras de caves, greniers et garages, avec évacuation des encombrants.",
    description:
      "Vidage de caves, greniers, garages et débarras divers : nous évacuons les encombrants et les déchets, puis nous balayons et remettons l'espace en état, propre et prêt à l'emploi.",
    image:
      "https://images.unsplash.com/photo-1765850257541-b70e125323d3?crop=entropy&cs=srgb&fm=jpg&q=80",
    subs: ["Vidage de caves", "Débarras de greniers", "Évacuation des encombrants", "Remise en état"],
  },
  {
    id: "entretien-regulier",
    title: "Entretien régulier",
    short:
      "Contrats d'entretien, interventions ponctuelles ou saisonnières, avec un suivi personnalisé.",
    description:
      "Contrats d'entretien, interventions ponctuelles, entretien saisonnier et suivi personnalisé : votre jardin bénéficie d'une attention régulière et adaptée à ses besoins.",
    image:
      "https://images.unsplash.com/photo-1788610830488-1343095c571c?crop=entropy&cs=srgb&fm=jpg&q=80",
    subs: ["Contrats d'entretien", "Interventions ponctuelles", "Entretien saisonnier", "Suivi personnalisé"],
  },
];

export const advantages = [
  {
    icon: "leaf",
    title: "Travail soigné",
    text: "Chaque intervention est réalisée avec attention et souci du détail.",
  },
  {
    icon: "wrench",
    title: "Professionnalisme",
    text: "Une équipe sérieuse, formée et équipée pour un résultat de qualité.",
  },
  {
    icon: "calendar",
    title: "Ponctualité",
    text: "Nous respectons les horaires et les rendez-vous convenus avec vous.",
  },
  {
    icon: "handshake",
    title: "Service personnalisé",
    text: "Chaque jardin étant différent, les prestations sont adaptées à vos besoins.",
  },
];

export const whyChoose = [
  {
    num: "01",
    title: "Un travail soigné",
    text: "Chaque intervention est réalisée avec attention et souci du détail.",
  },
  {
    num: "02",
    title: "Une approche personnalisée",
    text: "Chaque jardin étant différent, les prestations sont adaptées aux besoins du client.",
  },
  {
    num: "03",
    title: "Une équipe professionnelle",
    text: "Nous mettons un point d'honneur sur le sérieux, la ponctualité et la qualité du travail.",
  },
  {
    num: "04",
    title: "Des extérieurs toujours impeccables",
    text: "Notre objectif : vous permettre de profiter pleinement de vos espaces extérieurs.",
  },
];

export const method = [
  {
    num: "01",
    title: "Votre demande",
    text: "Vous nous expliquez votre projet ou vos besoins.",
  },
  {
    num: "02",
    title: "Évaluation",
    text: "Nous analysons votre espace extérieur et les travaux nécessaires.",
  },
  {
    num: "03",
    title: "Devis",
    text: "Vous recevez une proposition claire et adaptée.",
  },
  {
    num: "04",
    title: "Intervention",
    text: "Notre équipe réalise les travaux avec soin et professionnalisme.",
  },
];
